export const isBedroom = unitType => {
  const BEDROOM_TYPES = ['single-bed', 'double-bed', 'bedroom'];

  return BEDROOM_TYPES.includes(unitType);
};

export const isBed = unitType => {
  const BED_TYPES = ['bed', 'single-bed', 'double-bed'];

  return BED_TYPES.includes(unitType);
};

export const isWcOrBathroom = unitType => {
  const BATHROOM_TYPES = ['bathroom', 'wc'];

  return BATHROOM_TYPES.includes(unitType);
};

export const findBedType = (unitType, units, unit = null) => {
  const bedTypes = ['double-bed', 'single-bed', 'twin-bed', 'bed'];

  return bedTypes.find(bedType => {
    if (!unit) {
      const bedroom = units.find(({ type_code }) => type_code === 'bedroom');

      if (bedroom) {
        return bedroom.subunits.find(subunit => subunit.type_code === bedType)?.type_code;
      }
    }

    if (bedType === unitType) {
      return unitType;
    }

    return unit?.subunits?.find(subunit => subunit.type_code === bedType)?.type_code;
  });
};

export const findOutsideConnection = (features, units, unitFeatures = null) => {
  const outsideConnections = ['outside-area', 'balcony', 'window'];

  return outsideConnections.find(connection => {
    if (!unitFeatures) {
      return units.find(({ features }) =>
        features?.find(({ Code, Exists }) => (Code === connection && Exists ? Code : null))
      );
    }

    const propertyOutsideConnection = features?.find(({ Code, Exists }) =>
      Code === connection && Exists ? connection : null
    );

    return (
      propertyOutsideConnection ||
      unitFeatures?.find(({ Code, Exists }) => (Code === connection && Exists ? Code : null))
    );
  });
};

export const findBathroomType = (rentBy, baseUnits, subunits = []) => {
  if (rentBy === 'property') {
    return null;
  }

  if (rentBy === 'subunit' && baseUnits.find(({ type_code }) => type_code === 'bathroom')) {
    return 'common_bathroom';
  }

  return subunits?.find(({ type_code }) => type_code === 'bathroom') ? 'private_bathroom' : null;
};
